export class Path {

  public static readonly USER = {
    INSERT: "/ofw-registration/insert",
    GET_DETAIL: "/ofw-login/get",
    GET_SIGNED_URL: "/ofw-registration/get-signed-url",
    GET_OCR_ANALYZE: "/ofw-registration/ocr-passport-analyze",
    COMPARE_FACES: "/ofw-registration/compare-faces",
    RESET_PASSWORD: "/ofw-user/reset-password",
    GET_REGISTRATION_DETAILS: "ofw-user/get",
    GET_PASSPORT_IMAGES: "ofw-passport-image/list",
    DELETE_PASSPORT_IMAGE: "ofw-passport-image/delete",
    ADD_PASSPORT_IMAGE: "ofw-passport-image/insert",
    UPDATE_USER_DATA: "ofw-user/update",
    GET_VERIFICATION_CODE: "ofw-email-verifier/generate",
    VALIDATE_VERIFICATION_CODE: "ofw-email-verifier/submit"
  }

  public static readonly DASHBOARD = {
    GET_SHIPMENT_ONGOING_DATA:"ofw-booking/list-ofw-ongoing",
    GET_SHIPMENTS_HISTORICAL_DATA:"ofw-booking/list-ofw-historical",
    GET_CARDS_DATA:"ofw-booking-summary/get",
    GET_NOTIFICATIONS:"ofw-notification/list",
    POST_READ_NOTIFICATION:"ofw-notification/update_read"
  }

  public static readonly BOOKING = {
    ADD_BOOKING: "ofw-booking/insert",
    GET_BOOKING: "ofw-booking/get",
    SEND_DETAILS: "ofw-booking/send-details",
    GET_SIGNED_URL: "ofw-booking/get-signed-url",
    GET_STATUS_UPDATES: "ofw-booking/get-status-updates",
    CANCEL_BOOKING: "ofw-booking/cancel",
  }

  public static readonly CONSOLIDATOR = {
    GET_CONSOLIDATOR: "ofw-consolidator/list"
  }

  public static readonly HSCODE = {
    GET_HSCODE: "ofw-hs-code/list"
  }

  public static readonly GOOGLE_MAP = {
    GET_PLACE_AUTOCOMPLETE: "google-services/get-places-autocomplete"
  }

  public static readonly PRIVACY_POLICY = {
    GET_PRIVACY_POLICY: "ofw-data-privacy/get"
  }

  public static readonly SETTINGS = {
    GET_MAX_IMAGE_UPLOAD_LIMIT: "ofw-registration/get-passport-size-limit",
    GET_PASSPORT_DATE_FORMATS: "ofw-registration/get-passport-date-formats"
  }

  public static readonly GENERIC = {
    COUNTRY: "ofw-country/list",
    ERROR_EMAIL: "ofw-email-sender/send_error"
  }

}